











import Vue from 'vue';
import Component from 'vue-class-component';
import autoBind from 'auto-bind';
import { Router } from 'framework7/modules/router/router';
import { page } from 'vue-analytics';

import '@/globals';
import MainMenu from '@/components/main-menu.vue';
import Routes from '@/routes';
import { Poi, PoiState } from '@/models/poi';
import { delay } from '@/utils';
import { UserBadge } from './models/profile';
import UnityBridge from '@/unity-bridge';


@Component({
    components: {
        MainMenu,
    },
})
export default class App extends Vue {

    private toastQueueRunning: boolean = false;
    private toastQueue: any[] = [];

    // stackPages is set dynamically in the onRouteChangedEvent
    public f7params = {
        id: 'ch.listory.app',
        version: '1.1.0',
        name: 'LIstory',
        theme: 'md',
        routes: Routes,
        view: {
            pushState: true,
            mdSwipeBack: true,
            stackPages: false
        },
        statusbar: {
            enabled: false,
        },
    };

    public constructor() {
        super();
        autoBind(this);
    }

    public mounted() {
        this.$store.$on('poiReadyToUnlock', this.onPoiReadyToUnlock);
        this.$store.$on('badgeAchieved', this.onBadgeAchieved);
        this.$f7.views.main.router.on('routeChange', this.onRouteChange);
    }

    public beforeDestroy() {
        this.$store.$off('poiReadyToUnlock', this.onPoiReadyToUnlock);
        this.$store.$off('badgeAchieved', this.onBadgeAchieved);
        this.$f7.views.main.router.off('routeChange', this.onRouteChange);
    }

    private onRouteChange(newRoute: Router.Route, previousRoute: Router.Route, router: Router.Router) {

        page({
            page: newRoute.url,
            title: newRoute.name,
        });

        // turn stacking on
        if (newRoute.name == 'RouteDetailMap') {
            router.params.stackPages = true;
        }

        // turn stacking off
        if (newRoute.name == 'RouteMap') {
            router.params.stackPages = false;
        }
    }

    private onPoiReadyToUnlock(poi: Poi) {

        this.toastQueue.push({
            text: `<h1>${poi.title}</h1>${this.$t('toast.poi_unlocked')}`,
            position: 'bottom',
            cssClass: 'readyToUnlock',
            closeButton: true,
            closeButtonText: '<i class="material-icons">vpn_key</i>Öffnen ',
            closeButtonColor: 'blue',
            closeTimeout: 5000,
            closeAction: () => this.$f7.views.main.router.navigate('/pois/' + poi.id)
        });

        this.processToastQueue();

        this.$ga.event({
            eventCategory: 'poi',
            eventAction: 'readyToUnlock',
            eventLabel: poi.number,
        });
    }

    private onBadgeAchieved(badge: UserBadge) {
        this.toastQueue.push({
            text: `<h1>${this.$t('toast.badge_unlocked')}</h1>${badge.description}`,
            position: 'bottom',
            cssClass: 'readyToUnlock',
            closeButton: true,
            closeButtonText: '<i class="material-icons">beenhere</i>Anzeigen ',
            closeButtonColor: 'blue',
            closeTimeout: 5000,
            closeAction: () => this.$f7.views.main.router.navigate('/profile/')
        });

        this.processToastQueue();

        this.$ga.event({
            eventCategory: 'badge',
            eventAction: 'badgeAchieved',
            eventLabel: badge.title,
        });
    }

    public processToastQueue() {
        // setup running flag
        if (this.toastQueueRunning || this.toastQueue.length <= 0) { return; }
        this.toastQueueRunning = true;

        // find next valid toasts
        const toastMessage = this.toastQueue.shift();

        // if toast was found show it
        if (toastMessage) {
            // @ts-ignore
            const toast = this.$f7.toast.create(toastMessage);

            /* button clicked: show detail */
            toast.once('closeButtonClick', toastMessage.closeAction);

            /* closed: start next toast in queue */
            toast.once('closed', async () => {
                await delay(1000);
                this.toastQueueRunning = false;
                this.processToastQueue();
            });

            toast.open();
        } else {
            this.toastQueueRunning = false;
        }
    }
}
